export const config = {
    URI: 'https://api.estebansplace.com/v1'//'http://127.0.0.1:4001/v1'//
}